import { Link } from 'react-router-dom'
import SiteHeader from '@/components/SiteHeader'
import SiteFooter from '@/components/SiteFooter'

export default function NotFoundPage() {
  return (
    <div className="flex min-h-screen flex-col bg-warm-white">
      <SiteHeader />
      <main className="flex flex-1 items-center justify-center px-6 py-16 text-center">
        <div>
          <h1 className="mb-3 font-serif text-4xl">Page not found</h1>
          <p className="mb-6 text-ink-secondary">The page you're looking for doesn't exist.</p>
          <Link
            to="/"
            className="inline-block rounded-[10px] bg-brown px-6 py-3 text-[0.95rem] font-semibold text-white no-underline hover:bg-brown-dark"
          >
            Go home
          </Link>
        </div>
      </main>
      <SiteFooter />
    </div>
  )
}
